import axios from "axios";

const root = "/api/bms/report-template";
async function unwrap(request) {
  const { data } = await request;
  if (data.code !== 200) throw new Error(data.msg || data.message || "模板操作失败");
  return data.data;
}
export const listReportTemplates = () => unwrap(axios.get(root));
export const getReportTemplate = id => unwrap(axios.get(`${root}/${id}`));
export const createReportTemplate = data => unwrap(axios.post(`${root}/create`, data));
export const saveReportTemplateDraft = (id, data) => unwrap(axios.post(`${root}/${id}/draft`, data));
export const previewReportTemplate = (id, data) => unwrap(axios.post(`${root}/${id}/preview`, data));
export const publishReportTemplate = (id, data) => unwrap(axios.post(`${root}/${id}/publish`, data));
export const changeReportTemplateStatus = (id, data) => unwrap(axios.post(`${root}/${id}/status`, data));
export const rollbackReportTemplate = (id, data) => unwrap(axios.post(`${root}/${id}/rollback`, data));
export const listReportTemplateVersions = id => unwrap(axios.get(`${root}/${id}/versions`));
export const getReportTemplateVersion = (id, versionId) => unwrap(axios.get(`${root}/${id}/versions/${versionId}`));
